module.exports = __webpack_public_path__ + "img/carousel-servicios-2.bd811117.jpg";